import {
  isMobileOnly,
  isTablet,
  isBrowser,
  isChrome,
  isFirefox,
  isSafari,
  isIE,
  isEdge,
} from 'react-device-detect';

const initialState = {
  mobile: isMobileOnly,
  tablet: isTablet,
  desktop: isBrowser,
  chrome: isChrome,
  firefox: isFirefox,
  safari: isSafari,
  ie: isIE,
  edge: isEdge,
};

const device = (state: Object = initialState) => state;

export default device;
